/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {CompEvent} from "./CompEvent";
/**
 * Created by andrea on 2017-06-20.
 */

export class PurchasedEvent {

  public deviceOverride: string[] = [];

  constructor(public event: CompEvent, public dateAdded: Date, public datePurchased: Date) {

  }

  static fromAngularFireSnapshots(snapshot: any) : PurchasedEvent[] {
    return snapshot.map(snap => this._fromSnapshot(snap.key, snap.payload.val()));
  }

  static fromSnapshot(snap: any) {
    return PurchasedEvent._fromSnapshot(snap.key, snap.val());
  }

  private static _fromSnapshot(key: string, {dateAdded, datePurchased, override}) {
    let event = new CompEvent(key, null, null, null, null, null, 0);
    let purchase = new PurchasedEvent(event,
      dateAdded ? new Date(dateAdded) : null,
      datePurchased ? new Date(datePurchased) : null);

    if (override) {
      purchase.deviceOverride = Object.keys(override);
    }

    return purchase;
  }
}



// WEBPACK FOOTER //
// ./src/models/PurchasedEvent.ts